export const longMonth = (m) => (m ? new Date(`${m.slice(0, 7)}-01T00:00:00`).toLocaleDateString("en-AU", { month: "long", year: "numeric" }) : "");

// Green at/above base, orange within 10% below, red further below
export const changeTone = (cur, base) => (cur == null || base == null ? null : cur >= base ? "up" : base > 0 && cur / base >= 0.9 ? "near" : "down");

export const PACE = { up: "#10b981", near: "#f59e0b", down: "#fb7185" };
export const paceColor = (cur, base, fallback) => PACE[changeTone(cur, base)] || fallback;

export function changeText(cur, base, fmt, pts = false) {
  if (cur == null || base == null) return null;
  const d = cur - base;
  const s = d >= 0 ? "+" : "-";
  if (pts) return `${s}${Math.abs(d * 100).toFixed(1)} pts`;
  return `${s}${fmt(Math.abs(d))}${base ? ` (${s}${Math.abs((d / base) * 100).toFixed(1)}%)` : ""}`;
}


export function ChartTip({ title, tag, rows = [], change, testid = "chart-tip" }) {
  return (
    <div className="min-w-[220px] rounded-xl border border-slate-200 bg-white px-4 py-3 font-sans shadow-lg shadow-slate-900/10" data-testid={testid}>
      <div className="flex items-center justify-between gap-4">
        <p className="text-sm font-bold text-slate-900" data-testid={`${testid}-title`}>{title}</p>
        {tag && <span className="whitespace-nowrap rounded-md bg-sky-50 px-2 py-0.5 text-[11px] font-semibold text-sky-700" data-testid={`${testid}-tag`}>{tag}</span>}
      </div>
      <div className="mt-2 space-y-1.5">
        {rows.map((r) => (
          <div key={r.label} className="flex items-center justify-between gap-6 text-sm" data-testid={`${testid}-row`}>
            <span className="flex items-center gap-2 text-slate-600"><span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: r.color }} />{r.label}</span>
            <span className="font-bold tabular-nums text-slate-900">{r.value ?? "—"}</span>
          </div>
        ))}
      </div>
      {change?.text && (
        <div className="-mx-4 -mb-3 mt-3 flex items-center justify-between gap-6 rounded-b-xl border-t border-slate-100 bg-slate-50 px-4 py-2 text-xs" data-testid={`${testid}-change`}>
          <span className="text-slate-500">{change.label}</span>
          <span className="font-bold tabular-nums" style={{ color: PACE[change.tone] || "#64748b" }}>{change.text}</span>
        </div>
      )}
    </div>
  );
}
